// @flow
import React from 'react';
import AuthFormContainer from 'containers/auth/AuthFormContainer';
import AuthTemplate from 'components/auth/AuthTemplate';
import PageTemplate from 'components/base/PageTemplate';

const Forgot = () => {
  return (
    <AuthTemplate
      type={'비밀번호 재설정'}
      form={<AuthFormContainer typeName={'비밀번호 재설정'} />}
    />
  );
};

export default Forgot;



// WEBPACK FOOTER //
// ./src/pages/Forgot.js